import React from 'react';
import { useTranslation } from 'react-i18next';
import './styles.scss';
import PageBanner from 'components/PageBanner';
import Gastronomy from './components/Gastronomy';

function RestaurantsPage() {
    const { t } = useTranslation();

    return (
        <div className='restaurants-page'>
            <PageBanner
                title={t('menu.RESTAURANTS')}
                primaryPage={false}
                previous
            />
            <Gastronomy />
        </div>
    );
}

export default RestaurantsPage;
